import { render, staticRenderFns } from "./categoriasPtosTiendas.vue?vue&type=template&id=3c2816d2&scoped=true&"
import script from "./categoriasPtosTiendas.vue?vue&type=script&lang=js&"
export * from "./categoriasPtosTiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2816d2",
  null
  
)

export default component.exports